import { PrimaryButton, SourceFileLoader } from "@loanbossinc/component-library";
import styled from "styled-components/macro";
import { RadioGroup } from "@material-ui/core";

export const StyledPrimaryButton = styled(PrimaryButton)`
  && {
    background: #005aa9;
    font-size: 13px;
    margin-left: 1em;
    white-space: nowrap;
    width: auto;
  }
`;

export const IconWrapper = styled.div`
  && {
    padding: 6px 0.5em 0 0;
  }
`;

export const InputWrapper = styled.div`
  && {
    width: 100%;
  }
`;

export const ControlRow = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0 0.5em;
  }
`;

export const ControlRowItem = styled.div`
  && {
    padding: 0 0.5em;
    width: 100%;
  }
`;

export const LeftDetailWrapper = styled.div`
  && {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 0.5em;
    width: 70%;
  }
`;

export const RightDetailWrapper = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: row-reverse;
    padding-right: 1.5em;
    width: 30%;
  }
`;

export const SectionWrapper = styled.div`
  && {
    align-items: center;
    border-bottom: ${props => props.borderBottom || "1px solid #dadce0"};
    display: flex;
    padding: 1.5em 0;
  }
`;

export const StyledSourceFileLoader = styled(SourceFileLoader)`
  && {
    height: 100% !important;

    & .drop-zone-wrapper {
      height: 100% !important;
    }

    & button {
      width: 160px !important;
    }
  }
`;

export const InfoWrapper = styled.div`
  && {
    align-items: flex-start;
    display: flex;
    border-bottom: 1px solid #dadce0;
    padding-bottom: 1em;
  }
`;

export const RadioGroupWrapper = styled.div`
  && {
    width: 100%;
    padding-left: 0.5em;
  }
`;

export const StyledRadioGroup = styled(RadioGroup)`
  && {
    display: flex;
    justify-content: space-around;
    flex-direction: row;
    width: 100%;
  }
`;

export const LeftSectionWrapper = styled.div`
  && {
    align-items: center;
    display: flex;
    justify-content: center;
    padding-left: 0.5em;
    width: 50%;
  }
`;

export const HousesIconWrapper = styled.div`
  && {
    padding-left: 0.6em;
  }
`;

export const ConfirmationWrapper = styled.div`
  && {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0.5em;
  }
`;

export const BoldConfirmationTextWrapper = styled.div`
  && {
    font-size: 14px;
    font-weight: 600;
  }
`;

export const ConfirmationTextWrapper = styled.div`
  && {
    font-size: 14px;
    font-weight: 400;
  }
`;

export const RightSectionWrapper = styled.div`
  && {
    justify-content: space-between;
    display: flex;
    flex-direction: column;
    padding-left: 0.5em;
    width: 50%;
    height: 136px;
  }
`;

export const DescriptionWrapper = styled.div`
  && {
    color: #000000;
    font-size: 16px;
    font-weight: normal;
    line-height: 19px;
    padding-right: 0.7em;
  }
`;

export const PaddedWrapperFullWidth = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  padding: ${props => props.padding || "1.5em 1em"};
  width: 100%;
`;

export const ColumnWrapper = styled.div`
  && {
    display: flex;
    flex-direction: row;
    justify-content: ${props => props.justifyContent || "flex-start"};
  }
`;

export const Title = styled.div`
  font-family: Work Sans;
  font-size: ${props => props.fontSize || "24px"};
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0em;
  padding-top: ${props => props.paddingTop || 0};
  text-align: left;
`;

export const Row = styled.div`
  && {
    align-items: center;
    border-bottom: ${props => props.borderBottom || "1px solid #dadce0"};
    box-sizing: border-box;
    display: flex;
    min-height: 88px;
    justify-content: ${props => props.justifyContent || "space-between"};
    width: 100%;
  }
`;

export const CreateDateWrapper = styled.div`
  && {
    padding-left: 65px;
    font-family: Work Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }
`;

export const VersionUploadWrapper = styled.div`
  && {
    align-items: center;
    border-bottom: 1px solid #dadce0;
    display: flex;
    justify-content: center;
    padding: 1em;
  }
`;
